/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Difference_HelpInputs */



/**
* | output |
* | --- |
* | "Gap over the intervals read on both sides, excluding the one in progress." |
*
* @param {Consumption_Difference_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_difference_help = /** @type {((inputs?: Consumption_Difference_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Difference_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Gap over the intervals read on both sides, excluding the one in progress.")
	return /** @type {LocalizedString} */ ("Écart sur les intervalles relevés des deux côtés, hors intervalle en cours.")
});